import React, { memo, useState } from 'react';

import { Tooltip } from 'antd';
import moment from 'moment';

interface Props {
  date: string;
}

const MessageDate: React.FC<Props> = ({ date }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <Tooltip
      title={`${moment(date).format('MMM D')} at ${moment(date).format('h:mm A')}`}
      visible={isVisible}
      onVisibleChange={setIsVisible}
      mouseEnterDelay={0.5}
      placement="top"
    >
      {moment(date).format('h:mm A')}
    </Tooltip>
  );
};

export default memo(MessageDate);
